import axios from 'axios'
import SongBarChart from "../components/SongBarChart.jsx";
import Tag from "../components/Tag.jsx";
import { useNavigate, useLocation, useSearchParams } from "react-router";

import './home.css';


import { useState, useEffect, useRef } from 'react';

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";

const Home = () => {
    const [spinitronURL, setSpinitronURL] = useState("https://spinitron.com/WKNC/dj/173456/DJ-Sles");
    const [loading, setLoading] = useState(false);
    const [spinsData, setSpinsData] = useState([]);
    const [tags, setTags] = useState([]);
    const [artist, setArtist] = useState(null);
    const [searchArtist, setSearchArtist] = useState(null);
    const [dateAfter, setDateAfter] = useState("");
    const [dateBefore, setDateBefore] = useState("");
    const [isFromCache, setIsFromCache] = useState(false);
    const [unfilteredSpins, setUnfilteredSpins] = useState([]); //without filters
    const [searchParams, setSearchParams] = useSearchParams();

    const mode = process.env.REACT_APP_MODE || "default";
    console.log(mode);

    function setParam() {
        setSearchParams({ url: spinitronURL });
    }

    useEffect(() => {
        let url = searchParams.get('url');
        console.log(url);
        if(url) {
            setSpinitronURL(url);
            getSpins(url, false);
        }
    }, [searchParams])

    function getSpins(url, force) {
        setLoading(true);
        const regexp = new RegExp("https:\/\/spinitron.com\/.*\/dj\/.*\/.*");
        if(!url.match(regexp)) {
            console.log(url);
            setLoading(false);
            alert("Invalid URL. Are you sure you are using a DJ url and not a playlist url?");
            setSpinitronURL("");
            return;
        }
        console.log(force);
        if(!force) {
            const cachedSpins = JSON.parse(localStorage.getItem(url));
            if(cachedSpins) {
                setIsFromCache(true);
                let date = new Date(cachedSpins.date);
                console.log(date);
                setSpinsData(cachedSpins);
                setUnfilteredSpins(cachedSpins.spins);
                setLoading(false);
                setTags([]);
                return;
            }
        }
        let api_url = `/api/spins/${encodeURIComponent(url)}`;
        if(mode === "dev") {
            api_url = "http://localhost:8080" + api_url;
        }
        axios.get(api_url, {timeout: 100000}).then((response) => {
            console.log(response.data);
            setIsFromCache(false);
            setLoading(false);
            setUnfilteredSpins(response.data);
            let storedSpins = {
                date: new Date(),
                spins: response.data
            }
            setSpinsData(storedSpins);
            localStorage.setItem(url, JSON.stringify(storedSpins));
            setTags([]);
        });
                
    }

    


    // Spinitron timeslots look like "Nov 4, 2025 2:00 PM – 3:00 PM"; pull out just the date.
    function getSpinDateString(timeslot) {
        if (!timeslot) return null;
        const datePart = timeslot.split(/[–—-]/)[0].trim();
        const parsed = new Date(datePart);
        if (isNaN(parsed)) return null;
        const year = parsed.getFullYear();
        const month = String(parsed.getMonth() + 1).padStart(2, '0');
        const day = String(parsed.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    function filterByDateRange(spins, afterValue, beforeValue) {
        let filtered = spins;
        if (afterValue) {
            filtered = filtered.filter(spin => {
                const spinDate = getSpinDateString(spin.timeslot);
                return spinDate && spinDate >= afterValue;
            });
        }
        if (beforeValue) {
            filtered = filtered.filter(spin => {
                const spinDate = getSpinDateString(spin.timeslot);
                return spinDate && spinDate <= beforeValue;
            });
        }
        return filtered;
    }

    function applyFilters(artistValue, afterValue, beforeValue) {
        let filtered = unfilteredSpins;
        if (artistValue) {
            filtered = filtered.filter(spin => spin.artist.toLowerCase() == artistValue.toLowerCase());
        }
        filtered = filterByDateRange(filtered, afterValue, beforeValue);
        setSpinsData({date: spinsData.date, spins: filtered});
    }

    function filterArtist(artist) {
        setArtist(artist);
        applyFilters(artist, dateAfter, dateBefore);
    }

    function handleDateAfterChange(event) {
        const dateValue = event.target.value;
        setDateAfter(dateValue);
        applyFilters(artist, dateValue, dateBefore);
    }

    function handleDateBeforeChange(event) {
        const dateValue = event.target.value;
        setDateBefore(dateValue);
        applyFilters(artist, dateAfter, dateValue);
    }

    function clearArtistFilter() {
        setArtist(null);
        applyFilters(null, dateAfter, dateBefore);
    }

    function clearDateAfterFilter() {
        setDateAfter("");
        applyFilters(artist, "", dateBefore);
    }

    function clearDateBeforeFilter() {
        setDateBefore("");
        applyFilters(artist, dateAfter, "");
    }

    function handleSubmit(event) {
        event.preventDefault();
        filterArtist(searchArtist);
        setSearchArtist("");
    }


    
    // apiCall();
    return (
        <div className="container">

            <div>
                
                <form action={() => setParam()} className="form-group mb-3" >
                    <label for="spinitron-url" className="form-label">Paste your Spinitron DJ URL Here</label>
                    <div className="d-flex">
                        <input className="form-control m-1" placeholder="https://spinitron.com/.../dj/.../..."value={spinitronURL} name="spinitron-url" onChange={(e) => setSpinitronURL(e.target.value)}/>
                        <button className="btn btn-info m-1" type="submit">Enter</button>

                    </div>

                    
                    {loading ?
                        <div className="d-flex flex-column align-items-center text-center my-4">
                            <div className="spinner-border loading-spinner m-2" role="status">
                                <span className="sr-only"></span>

                            </div>
                            <div>Scraping Data...</div>
                        </div> : null
                    }
                    
                </form>
                {isFromCache && !loading ? 
                    <div className="border border-primary rounded p-1 m-1">
                        Data is cached from {(new Date(spinsData.date)).toString()}
                        <button className="btn btn-sm btn-info m-1" onClick={() => getSpins(spinitronURL, true)}>Refetch Data</button>
                    </div> : null
                    }
                {unfilteredSpins.length != 0 && !loading ? 
                <>
                    <h2>Top Artists</h2>
                    <div className="d-flex align-items-center flex-wrap">
                        <div className="d-flex align-items-center">
                            <label htmlFor="filter-date-after" className="fw-light fs-6 me-1">After:</label>
                            <input id="filter-date-after" className="form-control form-control-sm m-1" type="date" value={dateAfter} onChange={handleDateAfterChange}></input>
                        </div>
                        <div className="d-flex align-items-center">
                            <label htmlFor="filter-date-before" className="fw-light fs-6 me-1">Before:</label>
                            <input id="filter-date-before" className="form-control form-control-sm m-1" type="date" value={dateBefore} onChange={handleDateBeforeChange}></input>
                        </div>


                    </div>

                    <div className="m-2" >
                        
                        <SongBarChart data={filterByDateRange(unfilteredSpins, dateAfter, dateBefore)} filterArtist={filterArtist}></SongBarChart>
                    </div>
                    <div  className="my-2" id="played-songs">
                        <h2 >Played Songs</h2>
                        <div className="d-flex align-items-center flex-wrap">
                            {/* <div id="filter-by-artist" className="m-1 fw-light fs-6 ">Filter by Artist: </div> */}
                            <form className="d-flex align-items-center" onSubmit={handleSubmit}>
                                <input className="form-control form-control-sm" type="text" placeholder="Filter by Artist" value={searchArtist} onChange={(e) => setSearchArtist(e.target.value)}></input>
                                <button className="btn btn-sm btn-info m-1" type="submit">Enter</button>
                            </form>
                            {/* <div className="fw-light fs-6 me-2">or click artist name</div> */}




                        </div>


                        {spinsData.spins.length == 0 ?
                            <div className="text-danger my-2">
                                No songs match filter
                            </div> :
                            <div className="my-1 fw-light fs-6 ">Total songs: {spinsData.spins.length}</div>


                        }
                        <div className="d-flex align-items-center">
                            {artist == null ? null : <a onClick={clearArtistFilter}><Tag  data={artist}></Tag></a>}
                            {!dateAfter ? null : <a onClick={clearDateAfterFilter}><Tag data={"After " + new Date(dateAfter + 'T00:00:00').toLocaleDateString()}></Tag></a>}
                            {!dateBefore ? null : <a onClick={clearDateBeforeFilter}><Tag data={"Before " + new Date(dateBefore + 'T00:00:00').toLocaleDateString()}></Tag></a>}
                        </div>

                        {spinsData.spins.map(spin => (
                            <div className="row my-2">
                                <div className="col px-1 text-break">
                                    <a  onClick={() => filterArtist(spin.artist)} > <div className="p-1 fw-bold artistName">{spin.artist}</div></a>

                                </div>
                                <div className="col ">'{spin.song}'</div>
                                <div className="col text-break"><a target="_blank" href={'https://spinitron.com/' + spin.playlist} className="fw-light fs-6 ">{spin.timeslot}</a></div>
                                
                            </div>
                        ))}
                        <footer div className="py-5"></footer>
                        
                    </div>
                </> : null
                }  
            </div>

        </div>
    );
};

export default Home;